import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e9c5b94")

_pushScopeId("data-v-4e9c5b94")
const _hoisted_1 = {
  class: "topFixed",
  id: "topFixed"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "reportNum" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { class: "photoList" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "photoViewBox" }
const _hoisted_8 = { class: "photoViewCont" }
const _hoisted_9 = { class: "swiper" }
const _hoisted_10 = { class: "swiper-wrapper" }
const _hoisted_11 = { class: "swiperSlideCont" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "swiper-zoom-container" }
const _hoisted_14 = {
  key: 1,
  class: "changeBtn prevBtn"
}
const _hoisted_15 = {
  key: 2,
  class: "changeBtn nextBtn"
}
const _hoisted_16 = { key: 3 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: {'PC': _ctx.state.isPc, 'H5': !_ctx.state.isPc}
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h5", null, [
            _createVNode("span", null, "VIN:" + _toDisplayString(_ctx.state.vin), 1),
            _withDirectives(_createVNode("span", {
              class: "backList",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSwiper && _ctx.closeSwiper(...args)))
            }, "返回列表", 512), [
              [_vShow, _ctx.state.showSwiper && !_ctx.state.isPc]
            ])
          ]),
          _withDirectives(_createVNode("p", null, "报告编号：" + _toDisplayString(_ctx.state.reportCode), 513), [
            [_vShow, !_ctx.state.showSwiper && _ctx.state.isPc]
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.renderList, (item, index) => {
              return (_openBlock(), _createBlock("li", {
                key: index,
                onClick: ($event: any) => (_ctx.goGroup(index)),
                class: {'active': index === _ctx.state.currentTabIndex}
              }, _toDisplayString(item.name) + "(" + _toDisplayString(item.photoList.length) + ") ", 11, ["onClick"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.renderList, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "listItemGroup",
            key: index,
            id: `listItemGroup_${index}`
          }, [
            _createVNode("h6", null, _toDisplayString(item.name) + "(" + _toDisplayString(item.photoList.length) + ")", 1),
            _createVNode("ul", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.photoList, (photo, phIdx) => {
                return (_openBlock(), _createBlock("li", {
                  key: phIdx,
                  onClick: ($event: any) => (_ctx.openImgViewer(index, phIdx))
                }, [
                  _createVNode("img", {
                    src: photo.smallPhotoUrl
                  }, null, 8, ["src"]),
                  _createVNode("p", null, _toDisplayString(photo.photoName), 1)
                ], 8, ["onClick"]))
              }), 128))
            ])
          ], 8, ["id"]))
        }), 128))
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "swiper-slide",
                key: index
              }, [
                _createVNode("div", _hoisted_11, [
                  (_ctx.state.isPc)
                    ? (_openBlock(), _createBlock("p", _hoisted_12, [
                        _createVNode("span", null, _toDisplayString(_ctx.state.renderList[_ctx.state.currentTabIndex].name) + " " + _toDisplayString(_ctx.state.currentSlideIndex) + " / " + _toDisplayString(_ctx.state.currentGroupLength) + " " + _toDisplayString(item.photoName), 1),
                        _withDirectives(_createVNode("span", {
                          class: "backList",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeSwiper && _ctx.closeSwiper(...args)))
                        }, "返回列表", 512), [
                          [_vShow, _ctx.state.showSwiper && _ctx.state.isPc]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("img", {
                      src: item.bigPhotoUrl
                    }, null, 8, ["src"])
                  ]),
                  (_ctx.state.isPc)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode("img", {
                          src: require('@/assets/image/headIconLeft.png')
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.isPc)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode("img", {
                          src: require('@/assets/image/headIconLeft.png')
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.isPc)
                    ? (_openBlock(), _createBlock("p", _hoisted_16, [
                        _createVNode("span", null, _toDisplayString(item.photoName), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.state.currentSlideIndex) + " / " + _toDisplayString(_ctx.state.currentGroupLength), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.showSwiper]
    ])
  ], 2))
})